export interface IDevicePositionOutputDto {
    externalId: number;
    deviceId: number;
    latitude: string;
    longitude: string;
    locationTimestamp: string;
    insertTimestamp: string;
    bearing: number;
    fixAge: number;
    fixAccuracy: number;
    satelliteCount: number;
    ignition: number;
    speed: number;
    sourcePlatform: string;
}
